angular
  .module('countriesApp')
  .service('VisualizationsService', [
    '$q',
    'VISUALIZATION_ITEMS',
    'RequestService',
    'alertHandlingService',
    function ($q, VISUALIZATION_ITEMS, Request, AlertHandling) {
      const aggregations = {
        'sectors': null,
        'donors': null
      };

      /**
       * Performs a request to the API. It directly returns the response data (no model here), also
       * handles if there is an error during the request
       *
       * @param {number} id - Country ID for the URL
       * @param {string} method - RequestService method to be called
       * @param {string} callback - Function to be executed after calling the
       *                            RequestService method
       *
       * @returns {object} - Request promise object
       */
      const request = (id, method, callback) => method(id)
        .then(callback)
        .catch(() => {
          AlertHandling.showGenericErrorMessage();

          return null;
        });

      /**
       * Gets the aggregated sectors stored in the service, if there is no data stored, it performs
       * a GET request to the API to get the aggregated sectors of the given country
       *
       * @param {number} id - Country ID
       *
       * @returns {object} - Aggregated sectors promise object
       */
      const getSectorsByCountry = id => {
        if(aggregations.sectors) {
          return $q(resolve => resolve(aggregations.sectors));
        }

        const method = Request.getAggregatedSectorsByCountry;
        const callback = response => {
          aggregations.sectors = response.data.news_topics.slice(0, VISUALIZATION_ITEMS);

          return aggregations.sectors;
        };

        return request(id, method, callback);
      };

      /**
       * Gets the aggregated donors stored in the service, if there is no data stored, it performs a
       * GET request to the API to get the aggregated donors of the given country
       *
       * @param {number} id - Country ID
       *
       * @returns {object} - Aggregated donors promise object
       */
      const getDonorsByCountry = id => {
        if(aggregations.donors) {
          return $q(resolve => resolve(aggregations.donors));
        }

        const method = Request.getAggregatedDonorsByCountry;
        const callback = response => {
          aggregations.donors = response.data.donors.slice(0, VISUALIZATION_ITEMS);

          return aggregations.donors;
        };

        return request(id, method, callback);
      };

      return {
        'getSectorsByCountry': getSectorsByCountry,
        'getDonorsByCountry': getDonorsByCountry
      };
    }
  ]);
